import { useEffect, useRef } from 'react';
import { ConfettiFillIcon } from '@zep-us/zus-icons';
import { useRouter } from 'next/router';
import { Trans, useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { useLocale } from '@/hooks';
import { PromotionModal } from '@/shared/components/PromotionModal';
interface PhoneVerificationBannerModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDismissForToday: () => void;
}
export const PhoneVerificationBannerModal = ({
  isOpen,
  onClose,
  onDismissForToday
}: PhoneVerificationBannerModalProps) => {
  const router = useRouter();
  const {
    t
  } = useTranslation(['common']);
  const {
    locale
  } = useLocale();
  const hasTrackedView = useRef(false);
  const imageUrl = locale === 'ko' ? '/assets/phone_verification_event_banner.webp' : '/assets/phone_verification_event_banner_en.webp';
  const trackEvent = (eventName: string) => {
    logger.track(eventName, {
      from: 'banner_modal'
    });
  };
  useEffect(() => {
    if (isOpen && !hasTrackedView.current) {
      trackEvent('phone_verification_banner_modal_view');
      hasTrackedView.current = true;
    }
  }, [isOpen]);
  const handleCtaClick = () => {
    trackEvent('phone_verification_banner_modal_cta_click');
    onClose();
    void router.push({
      pathname: '/verification-phone',
      query: {
        from: 'banner_modal'
      }
    });
  };
  const handleDismissClick = () => {
    trackEvent('phone_verification_banner_modal_dismiss');
    onDismissForToday();
    onClose();
  };
  return <PromotionModal isOpen={isOpen} onClose={onClose} title={<Trans t={t} i18nKey="phoneVerify.bannerModal.title" components={{
    br: <br />
  }} />} description={<Trans t={t} i18nKey="phoneVerify.bannerModal.description" components={{
    br: <br />
  }} />} imageUrl={imageUrl} badge={{
    icon: <ConfettiFillIcon size="2xs" />,
    label: t('global.event')
  }} primaryLabel={t('phoneVerify.bannerModal.confirmButton')} onPrimaryClick={handleCtaClick} secondaryLabel={t('phoneVerify.bannerModal.dismissButton')} onSecondaryClick={handleDismissClick} data-sentry-element="PromotionModal" data-sentry-component="PhoneVerificationBannerModal" data-sentry-source-file="PhoneVerificationBannerModal.tsx" />;
};